import { Alert } from "antd";
import { useEffect, useState } from "react";

function DisterbuterFIlter({ setPage, submitForm, initialValues, params, setFilterKey, getReailerDistIdAgainst }) {
    const [formData, setFormData] = useState({
        name: '',
        mobile: '+91',
        email: '',
        refer_id: '',
        kycStatus: 'verified'
    });
    const [error, setError] = useState('');
    const [isSearchDisabled, setIsSearchDisabled] = useState(false);

    useEffect(() => {
        setFormData({
            name: '',
            mobile: '+91',
            email: '',
            refer_id: '',
            kycStatus: ''
        });
    }, [params]);

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handlePhoneChange = (event) => {
        const { value } = event.target;
        let newValue = value;

        // Ensure the value always starts with +91
        if (!newValue.startsWith('+91')) {
            newValue = '+91' + newValue.replace('+91', '');
        }

        // Remove any non-digit characters after +91
        newValue = '+91' + newValue.slice(3).replace(/\D/g, '');

        // Limit the total length to 13 (+91 + 10 digits)
        newValue = newValue.slice(0, 13);

        // Validate phone number format
        const mobileRegex = /^\+91\d{10}$/;
        if (!mobileRegex.test(newValue)) {
            setError('Invalid mobile number. Please enter a 10-digit number after +91.');
            setIsSearchDisabled(true);
        } else {
            setError('');
            setIsSearchDisabled(false);
        }

        // Update form data
        setFormData((prevData) => ({ ...prevData, mobile: newValue }));
    };



    const handleSubmit = (e) => {
        e.preventDefault();
        if (error) {
            // Prevent form submission if there's an error
            return;
        }
        submitForm(formData);
    };

    const resetForm = () => {
        setFilterKey(null)
        setFormData({
            name: '',
            mobile: '',
            email: '',
            refer_id: '',
            kycStatus: ''
        });
        setPage(0)
        getReailerDistIdAgainst(0 , true);
    };

    return (
        <>
            <div className="row m-4">
                <div className="col-xl-12" style={{ padding: "0" }}>
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="table-responsive active-projects style-1">
                                <div className="tbl-caption tbl-caption-2">
                                    <h4 className="heading mb-0"><b>Filter &nbsp;{`${params?.name}`}  </b></h4>
                                </div>
                                <form className="row cusforms" style={{ padding: "20px" }} onSubmit={handleSubmit}>
                                    <div className="form-group col-4">
                                        {/* <label htmlFor="name">Name</label> */}
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            placeholder="Enter name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group col-4">
                                        {/* <label htmlFor="mobile">Mobile Number</label> */}
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="mobile"
                                            placeholder="Enter 10-digit mobile number"
                                            value={formData.mobile}
                                            onChange={handlePhoneChange}
                                        />
                                    </div>
                                    <div className="form-group col-4">
                                        {/* <label htmlFor="email">Email</label> */}
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            placeholder="Enter email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group col-4">
                                        {/* <label htmlFor="refer_id">{params?.name} Ref id</label> */}
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="refer_id"
                                            placeholder={`Enter ${params?.name} ref id`}
                                            value={formData.refer_id}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="form-group col-4">
                                        {/* <label htmlFor="kycStatus">KYC Status</label> */}
                                        <select
                                            className="form-control"
                                            id="kycStatus"
                                            value={formData.kycStatus}
                                            onChange={handleChange}
                                        >
                                            <option value="" disabled>Select KYC Status </option>
                                            <option value="verified">verified </option>
                                            <option value="unverified">unverified </option>
                                        </select>
                                    </div>
                                    <div className="form-group col-12">
                                        {error ? (<Alert message="Warning" description={error} type="warning" showIcon closable />) : ""}
                                    </div>
                                    <div className="form-group col-12" style={{ margin: "20px 0" }}>
                                        <button type="submit" className="btn btn-primary" disabled={isSearchDisabled}>
                                            SEARCH
                                        </button>
                                        <button type="button" className="btn btn-secondary" onClick={resetForm}>
                                            RESET
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DisterbuterFIlter;
